import dayjs from 'dayjs'

const format = "MM/DD/YYYY"
const dateToString = (date, customFormat) => date ? dayjs(date).format(customFormat || format).toString() : null
const stringToDate = date => date ? dayjs(date).toDate() : null

export { dateToString, stringToDate}